export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13893.560c54e4.jpg";